import { gql } from '@apollo/client/core';

export const RESOLVE_SCHOOL = gql`
  query ResolveSchool($slug: String, $domain: String) {
    resolveSchool(slug: $slug, domain: $domain) {
      school_id
      school_name
      logo
      app_name
      primary_color
      accent_color
      favicon_url
      login_bg_url
      hide_gradeverse_branding
      frontend_url
    }
  }
`;
